import React, { useEffect } from 'react'
import { RouteComponentProps } from 'react-router'
import { Dispatch } from 'redux'
import { InfoOutlined, PhotoOutlined } from '@material-ui/icons'
import { IMediaTypeGroup } from '../../types/mediaTypeGroup'
import { Modals } from '../../types/modal'
import {
  getMediaTypeGroupById,
  deleteMediaTypeGroup,
} from '../../actions/mediaTypeGroup'
import { modalClose, modalOpen } from '../../actions/modal'
import { Main, Scrollable, SettingFormsWrapper } from '../../layouts'
import { UpdateMediaTypeGroupForm } from '../../forms'
import {
  CombinedTitle,
  TabsHead,
  View,
  SettingsMenu,
  P,
  Modal,
  SettingDeleteArea,
} from '../../components'
import { SelectMediaTypesTab } from './SelectMediaTypesTab'

export interface IMediaTypeGroupSettingsPageConnectedProps {
  mediaTypeGroup: IMediaTypeGroup
  activeModal?: string
  canEditMediaTypeGroups: boolean
  dispatch: Dispatch
}

export const MediaTypeGroupSettingsPage = ({
  match: {
    params: { id },
  },
  mediaTypeGroup,
  activeModal,
  canEditMediaTypeGroups,
  dispatch,
}: IMediaTypeGroupSettingsPageConnectedProps & RouteComponentProps<{ id }>) => {
  useEffect(() => {
    dispatch(getMediaTypeGroupById(id))
  }, [id, dispatch])

  return (
    <Main
      sidebarSecondary={<SettingsMenu />}
      titleBlock={
        <>
          <CombinedTitle
            first={mediaTypeGroup.title}
            second="Media Type Group Settings"
          />
          <TabsHead
            tabs={[
              {
                label: 'Details',
                value: 'details',
                icon: <InfoOutlined />,
              },
              {
                label: 'Media types',
                value: 'media-types',
                icon: <PhotoOutlined />,
              },
            ]}
          />
        </>
      }
      helmet="Administration: Media Type Groups"
    >
      <View keep tab="details">
        <Scrollable>
          <SettingFormsWrapper>
            <UpdateMediaTypeGroupForm
              mediaTypeGroup={mediaTypeGroup}
              editable={canEditMediaTypeGroups}
            />
            <SettingDeleteArea
              onClickHandler={() =>
                dispatch(modalOpen(Modals.deleteConfirmModal))
              }
              texts={{
                title: 'Delete media type group',
                description:
                  "This won't delete media types this group. Also please note that this action is not reversible and cannot be undone.",
                buttonLabel: 'Delete this Media Type Group',
              }}
              buttonProps={{ id: 'delete-media-type-group-dialog' }}
              disabled={!canEditMediaTypeGroups}
            />
          </SettingFormsWrapper>
        </Scrollable>
        <Modal
          open={activeModal === Modals.deleteConfirmModal}
          handleClose={() => {
            dispatch(modalClose())
          }}
          action={() => {
            dispatch(deleteMediaTypeGroup(mediaTypeGroup.id))
            dispatch(modalClose())
          }}
          title="Media Type Group deletion"
          actionLabel="Delete"
        >
          <P mb="true">
            This Media Type Group <strong>{mediaTypeGroup.title}</strong> will
            be deleted - please note that this action is not reversible and
            cannot be undone.
          </P>
          <P>
            Are you sure you want to delete the Media Type Group{' '}
            <strong>{mediaTypeGroup.title}</strong>?
          </P>
        </Modal>
        <Modal
          id="delete-pack-modal-dialog"
          type="info"
          open={activeModal === Modals.deleteStatusModal}
          handleClose={() => {
            dispatch(modalClose())
          }}
          title={`This Media Type Group ${mediaTypeGroup.title} can’t be deleted`}
        >
          <P>{mediaTypeGroup.message}</P>
        </Modal>
      </View>
      <View keep tab="media-types">
        <SelectMediaTypesTab mediaTypeGroup={mediaTypeGroup} />
      </View>
    </Main>
  )
}
